/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "antd";
import "./HomeModal.css";
/* DUCKS */
import { getBanderaHomeModal, getImageHomeModal } from '../../../redux/home/HomeModalDuck';


export const HomeModal = () => {
 
    //Declaracion Dispatch
    const dispatch = useDispatch();
    
    //Lectura de propiedades de STORE
    const homeModalStore = useSelector(
        (state) => state.homeModalStore
        );
           
    //States
    const [modalView, setModalView] = useState(null);

    useEffect(() => {
        loadInitial();
    }, []);

    useEffect(() => {
        if(homeModalStore.banderaHomeModal !== null){
            openModalHome();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [homeModalStore.banderaHomeModal]);

    const loadInitial = () => {
        dispatch(getBanderaHomeModal());
        dispatch(getImageHomeModal());
    };

    const hasWindow = typeof window !== "undefined";
    const getWindowDimensions = () => {
        const width = hasWindow ? window.innerWidth : null;
        const height = hasWindow ? window.innerHeight : null;
        return {
        width,
        height,
        };
    };

    const openModalHome = () => {
        if (getWindowDimensions().width > 500) {
            if(homeModalStore.banderaHomeModal === "1"){
                setModalView(true);
                const interval = setTimeout(() => {
                    setModalView(false);
                }, 5 * 1000);
                return () => clearInterval(interval);
            }
        }
    }

    const closeModalHome = () => {
        setModalView(false);
    };

    return (
        <>
        <Modal
            title={<div style={{ paddingTop: "15px" }}></div>}
            centered
            visible={modalView}
            onCancel={closeModalHome}
            className="modalHome"
            
        >
            <div className="container-img">
                {homeModalStore.imageHomeModal !== '' && 
                    <img src={`data:image/svg+xml;base64,${homeModalStore.imageHomeModal}`} alt="Imagen Modal Home" />
                }
            </div>            
        </Modal>
        </>
    );
};